export default __webpack_public_path__ + "media/images/shapes/inverted-slice-30257a7b3299d4710b8bb5312ac6fdd0.svg";